export enum PageContext {
  SearchPage = 'searchPage',
  SortDetailPageDiscover = 'sortDetailPageDiscover',
  SortDetailPageHome = 'sortDetailPageHome',
  GameDetailPage = 'gameDetailPage',
  GamesPage = 'gamesPage',
  HomePage = 'homePage',
  PeopleListInHomePage = 'peopleListInHomePage',
  InterestCatcher = 'interestCatcher'
}

export default {
  PageContext
};
